module.exports = __webpack_public_path__ + "assets/img/alipay.7591fd55.jpg";